"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { getFormula } from '@membranehq/sdk';
import { useComboBox } from '../../../context/use-combobox.mjs';
import { useComboBoxDropdownContext } from '../../../context/use-combobox-dropdown.mjs';
import { useFormulaComponents } from '../../../../DataBuilder/Formula/use-formula-components.mjs';
import { useKeyboardEventSubscribe, EVENT_TYPE } from '../../../../../helpers/hooks/keyboard-events.mjs';
import { withSlotScopeClasses } from '../../../../../helpers/scoped-slots.mjs';
import { useState, useEffect } from 'react';
import { tv } from 'tailwind-variants';
import { Button } from '../../../../../ui-kit/button.mjs';

const formulaConfigRecipe = tv({
  slots: withSlotScopeClasses("formula-config", {
    container: "flex flex-col p-1.5 gap-2 overflow-y-scroll",
    form: "flex-1 overflow-x-auto w-[min(30rem,70vw)] min-h-14",
    "save-button": "w-fit h-fit rounded-xl text-slate-11 px-2 py-1 mt-1"
  })
});
function DropdownPanelFormulaConfig({ onOptionSelect }) {
  const styles = formulaConfigRecipe();
  const formulaComponentMapping = useFormulaComponents();
  const { value, schema, variablesSchema, scopedComboboxId } = useComboBox();
  const { drillUp } = useComboBoxDropdownContext();
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [JSON.stringify(value)]);
  useKeyboardEventSubscribe({
    scopedComboboxId,
    event: EVENT_TYPE.OPTION_LEFT,
    callback: () => {
      drillUp();
    }
  });
  const formula = getFormula(localValue);
  const formulaMapping = formula?.type && formulaComponentMapping[formula?.type];
  function handleOnChange(newValue) {
    setLocalValue(newValue);
  }
  function handleOnSaveAndClose() {
    onOptionSelect(localValue);
  }
  if (!formulaMapping?.DropdownComponent) {
    return null;
  }
  const FormulaInDropdownPanelComponent = formulaMapping?.DropdownComponent;
  return /* @__PURE__ */ jsxs("div", { className: styles.container(), children: [
    /* @__PURE__ */ jsx("div", { className: styles.form(), children: /* @__PURE__ */ jsx(
      FormulaInDropdownPanelComponent,
      {
        formula,
        schema,
        variablesSchema,
        onChange: handleOnChange
      }
    ) }),
    /* @__PURE__ */ jsx("hr", { className: "border-0 border-t border-border-default" }),
    /* @__PURE__ */ jsx(
      Button,
      {
        onClick: handleOnSaveAndClose,
        variant: "outline",
        colorPalette: "gray",
        size: "sm",
        className: styles["save-button"](),
        children: "Save and Close"
      }
    )
  ] });
}

export { DropdownPanelFormulaConfig };
